export default __webpack_public_path__ + "static/media/add_to_home_screen_footer.31cdadd9.png";